import { List } from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, isLoaded } from 'react-redux-firebase'
import { compose } from 'redux'

import { fsCollections } from '../../helpers/firestore'

import { Championship } from '../../schemas/Championship'
import './ChampionshipList.css'
import { ChampionshipListItem } from './ChampionshipListItem'

type ChampionshipListProps = {
  baseUrl: string
  tenant: string
  admin: boolean
  championships: Championship[]
  removeChampionship(): void
}

class ChampionshipList extends React.Component<ChampionshipListProps, any> {
  // https://medium.freecodecamp.org/react-pattern-extract-child-components-to-avoid-binding-e3ad8310725e
  renderListItem = (championship) => {
    const { tenant, admin, removeChampionship } = this.props

    return (
      <ChampionshipListItem
        admin={admin}
        tenant={tenant}
        championship={championship}
        removeChampionship={removeChampionship}
      />
    )
  }

  render() {
    const { championships } = this.props

    return (
      <div className="ChampionshipList">
        <List
          itemLayout="vertical"
          size="default"
          loading={!isLoaded(championships)}
          dataSource={championships || []}
          renderItem={this.renderListItem}
        />
      </div>
    )
  }
}

export default compose<FIXME>(
  firestoreConnect<FIXME>(({ tenant, admin }) => [
    {
      collection: fsCollections.championships(tenant),
      // where: admin ? [] : ['public', '==', true],
      orderBy: ['dateFrom', 'desc'],
    },
  ]),
  connect(({ firestore, firebase: { profile, auth } }: FIXME, { tenant }: FIXME) => ({
    championships: firestore.ordered[fsCollections.championships(tenant)],
    profile,
    auth,
  })),
)(ChampionshipList)



// WEBPACK FOOTER //
// ./src/components/championship/ChampionshipList.tsx